import React from 'react';
import { Row, Col } from 'antd';
import { useEffect, useRef } from 'react';

import { InfoTooltip } from '../../../../components/InfoTooltip';
import { VideoContainer } from './styles';

interface VideoProps {
	url?: string;
	frame: number;
	onError?: () => void;
}

export function Video({ url, frame, onError }: Readonly<VideoProps>): JSX.Element {
	const videoRef = useRef<HTMLVideoElement>(null);

	useEffect(() => {
		function handleSetCurrentTime(): void {
			if (videoRef.current && url) {
				videoRef.current.currentTime = frame;
			}
		}

		if (!videoRef.current || !url) {
			return;
		}

		videoRef.current.load();

		if (videoRef.current.readyState >= 1) {
			handleSetCurrentTime();
			return;
		}

		videoRef.current.addEventListener('loadedmetadata', handleSetCurrentTime);

		return () => {
			videoRef.current?.removeEventListener('loadedmetadata', handleSetCurrentTime);
		};
	}, [url, frame]);

	return (
		<Row style={{ position: 'relative' }}>
			<Col span={23}>
				<VideoContainer>
					<video width="100%" height="100%" ref={videoRef} preload="metadata" onError={onError}>
						<source src={url} type="video/webm" />
						<source src={url} type="video/mp4" />
					</video>
				</VideoContainer>
			</Col>
			<Col style={{ position: 'absolute', top: -15, right: 0 }}>
				<InfoTooltip message="The colors shown do not refer to the OWAS tool." />
			</Col>
		</Row>
	);
}
